import { resolveUrl } from './api.ts';

/** REST mot Qvenari-API — på qvenari.com måste URL absolut peka på VITE_API_URL, inte Firebase. */
export function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(resolveUrl(path), init);
}
